import { cn } from '@/shared/lib/utils';
import type { HTMLAttributes, KeyboardEvent } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** 카드 전체를 누를 수 있으면 넘긴다 — 호버 그림자 + Enter/Space 지원 */
  onPress?: () => void;
}

/** Figma card/* — 흰 배경 · radius 20 · padding 16 의 목록 카드 */
export function Card({ onPress, className, children, ...props }: CardProps) {
  const interactive = Boolean(onPress);

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onPress?.();
    }
  };

  return (
    <div
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onPress}
      onKeyDown={interactive ? handleKeyDown : undefined}
      className={cn(
        'flex w-full items-start rounded-20 bg-surface-white p-4',
        interactive &&
          'cursor-pointer text-left transition-shadow outline-none hover:shadow-card-hover focus-visible:shadow-card-hover focus-visible:ring-2 focus-visible:ring-fg-accent/40',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
